"use client";

import Link from "next/link";
import type { ToolQuotaError } from "@/hooks/useToolFetch";

interface SignupGateModalProps {
  quotaError: ToolQuotaError;
}

export default function SignupGateModal({ quotaError }: SignupGateModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-ink/50 backdrop-blur-sm">
      <div className="mx-4 w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        {/* Lock icon */}
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-50">
          <svg
            className="h-7 w-7 text-amber-600"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
            />
          </svg>
        </div>

        <h2 className="mt-5 text-center font-display text-xl font-bold text-slate-900">
          Free limit reached
        </h2>
        <p className="mt-2 text-center text-sm text-slate-500 leading-relaxed">
          You&apos;ve used all {quotaError.limit} free uses today. Create a free
          account to get <strong className="text-slate-700">50 uses per day</strong>.
        </p>

        <div className="mt-6 space-y-3">
          <Link
            href="/register"
            className="flex w-full items-center justify-center rounded-xl bg-brand-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-brand-700 transition-colors"
          >
            Create free account
          </Link>
          <Link
            href="/login"
            className="flex w-full items-center justify-center rounded-xl border border-slate-200 px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
          >
            Already have an account? Sign in
          </Link>
        </div>

        <p className="mt-4 text-center text-xs text-slate-400">
          No credit card required. Free forever.
        </p>
      </div>
    </div>
  );
}
